import { css } from '@emotion/react';
import { atoms, Button, Link } from '@zapier/marketing-ui';
import { urls } from '@zapier/identity-utils';

type Props = {
  currentUser: any;
  onClick: () => void;
  next?: string;
};

const rootCss = css`
  display: grid;
  grid-gap: 25px;
`;

export function LoggedInMessage({ currentUser, onClick, next }: Props) {
  return (
    <div css={rootCss}>
      <p className={`${atoms.body} ${atoms.textCenter} fs-exclude`}>
        You are currently logged in as {currentUser.email}
      </p>
      <Button
        href={next || urls.DEFAULT_LOGIN_NEXT}
        fullWidth={true}
        variant="brand"
      >
        Continue
      </Button>
      <p className={`${atoms.body} ${atoms.textCenter}`}>
        <Link onClick={onClick}>Sign up as a different person</Link>
      </p>
    </div>
  );
}
